<!--
    @name: 工种报价搜索
    @description:
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-08-26 16:44:33
-->
<template>
  <div :style="{ paddingTop: top ? '10px' : 0 }">
   <!--  <ScreenSort
      @changeobj="changeobj"
      :config="['secondCategory', 'workType', 'locationAddress']"
      :secondCategoryi="3"
      :getquery="true"
    ></ScreenSort> -->
    <!-- 没有工种名称的 -->
    <ScreenSort
      @changeobj="changeobj"
      :config="['secondCategory', 'locationAddress']"
      :secondCategoryi="3"
      :getquery="true"
    ></ScreenSort>
    <!-- 排序按钮组 -->
    <SortBtn :update="update" :isShowDistance="false"></SortBtn>
    <div class="table" v-loading="loading">
      <div style="padding: 0 20px 10px 20px">
        <el-row :gutter="20" v-if="list.length">
          <el-col v-for="(item, index) in list" :span="12" :key="index">
            <card :item="item" :type="5"></card>
          </el-col>
          <template>
              <el-col :span="24" class="course-loading-wrap" v-if="moreLoading">
                数据加载中... <i class="el-icon-loading loading-icon"></i>
              </el-col>
              <el-col :span="24" class="course-loading-wrap" v-if="!moreLoading && nomore">没有更多数据了!</el-col>
            </template>
        </el-row>

        <div
          v-if="!list.length && !loading"
          style="width: 1200px; margin: 0 auto; margin-bottom: 10px"
        >
          <BaseEmptyData></BaseEmptyData>
        </div>
      </div>
    </div>
    <!-- <Pagination
      v-if="param.total > 0 && !loading"
      :param="param"
      @change="getlist"
      :loading="loading"
    ></Pagination> -->
  </div>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import SortBtn from "@/components/sortBtnGroup/SortBtn"
const throttle = require("lodash/throttle");

export default {
  name: "teamPrice",
  components: {
    ScreenSort: () => import("@/components/screenSort/screenSort"),
    Pagination: () => import("@/components/card/page"),
    card: () => import("@/components/card/cardVolunteerTeamOffer.vue"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    SortBtn
  },
  props: {
    top: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      moreLoading: false, //加载更多
      nomore: false, //没有数据显示
      list: [],
      params: {},
      param: {
        page: 1,
        limit: 40,
        total: 0,
        sortType:1,
        totalPages: 0
      },
      update:true
    }
  },
    watch: {
    // 页数改变的时候
    "param.page": {
      handler(val) {
        if (val > this.param.totalPages) {
          this.nomore = true;
        } else {
          this.nomore = false;
        }
      },
    },
   },
  methods: {
    getlist() {
      this.moreLoading = true //加载更多显示
      let params = { ...this.params }
      params.page = this.param.page
      params.limit = this.param.limit  
      params.sortType = this.param.sortType  
      apiResignAll.teamInfoSearchListNew(null,params)
        .then(res => {
          if (res && res.data.code == 200) {
            this.param.total = res.data.data.total
            this.$parent.count2 = res.data.data.total
            this.param.totalPages=res.data.data.pages;
            this.list = [...this.list,...res.data.data.records]           
          }
        })
        .finally(() => {
          this.loading = false
          this.moreLoading = false //加载更多隐藏
        })
    },
       // 页面滚动
    windowScroll: throttle(
      function () {
        // 如果当前页数大于总页数 则不去获取
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        let clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        /**
         * clientHeight 视口大小
         * scrollHeight 文档高度
         */
        if (scrollTop + clientHeight >= scrollHeight - 300) {
          this.param.page += 1;
          if (this.param.page <= this.param.totalPages) {
            this.getlist()
          }
        }
      },
      1500,
      { leading: false, trailing: true }
    ),
    changeobj(obj) {
      this.param.page = 1
      this.list=[]
      this.loading=true
      let params = {}
      //获取工程分类
      ;[
        "firstCategoryNo",
        "secondCategoryNo",
        "thirdCategoryNo",
        "fourCategoryNo",
        "fifthCategoryNo",
        "sixthCategoryNo"
      ].forEach((v, i) => {
        if (obj.secondCategory) {
          params[v] = obj.secondCategory[i] ? obj.secondCategory[i].no : ""
        } else {
          params[v] = ""
        }
      })
      //获取工种名称
      params.workType =
        obj.workType && obj.workType[0] ? obj.workType[0].no : ""
      //获取地区
      params.provinceNo = obj.locationAddresscode.provinceId
      params.cityNo = obj.locationAddress?obj.locationAddresscode.cityId:'';
      params.areaNoList = obj.locationAddress
        ? obj.locationAddress.map(v => {
            return v.no
          })
        : []
      if(obj.locationAddresscode.isAll){
        params.areaNoList=params.areaNoList[0]
      }
      //获取搜索值
      params.keyWord = localStorage.getItem("search_query")
      //设置值
      this.params = params
      this.getlist()
    },
    getList() {
      this.param.page = 1
      this.list=[]
      this.loading=true
      this.getlist()
    }
  },
  mounted() {
    document.addEventListener("scroll", this.windowScroll);
  },
    beforeDestroy() {
    document.removeEventListener("scroll",  this.windowScroll);
  },
  provide() {
    return {
      cardListCom: this
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  position: relative;
   width: 1198px;
  margin: 0 auto;
  overflow: hidden;
  min-height: 400px;
  background: white;
  border-top: none;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed;
  /deep/ .right {
    right: 0;
  }
}
.course-loading-wrap {
    display: flex;
    padding-top: 10px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    color: #999;
    background: #fff;
    .loading-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }
</style>
